// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
import { Environment } from "@kalmarenergi/util/models";

export const environment: Environment = {
  production: false,
  baseApi: "https://ke-apim-dev.azure-api.net/",
  loginUrl: "https://auth-dev.apps.kalmarenergi.se/",
  clientId: "portal",
  audiences: [
    "aurora-api",
    "notification-api",
    "meter-control-api",
    "outage-api",
    "schedule-api",
    "logging-api",
  ],
  realmProviderRealm: "realm-provider",
};
